import React, { useEffect, useState } from "react";
import { Button, Form, Input, notification } from "antd";
import Select from "react-select";
import parsePhoneNumberFromString, { AsYouType, isValidPhoneNumber, isPossiblePhoneNumber } from "libphonenumber-js";
import { FormWrapper } from "../form";
import { useApolloClient, useQuery } from "react-apollo";
import gql from "graphql-tag";
import { countriesSort, extractPhone, formatNumber } from "../../utils/formatter";
const FormItem = Form.Item;
const InputGroup = Input.Group;

const PhoneInput = ({ countryCode, value, onChange }) => {
  const handleChange = (event) => {
    const input = event.target.value;
    if (event.nativeEvent.inputType === "deleteContentBackward") {
      const digitsOnly = input.replace(/\D/g, "");
      const isValid = isValidPhoneNumber(digitsOnly, countryCode);
      if (!isValid && input.length < 6) onChange(digitsOnly);
      else onChange(new AsYouType(countryCode).input(digitsOnly));
    } else {
      const formatter = new AsYouType(countryCode);
      const formatted = formatter.input(input);
      onChange(formatted);
    }
  };

  return <Input type="text" value={value} onChange={handleChange} placeholder="" className="phoneInputbox" size={"large"} />;
};

const changePhoneNumber = (props) => {
  const { form, setChangePhoneShow, currentLogin, refetch } = props;
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);
  const { getFieldProps, getFieldDecorator, getFieldValue } = form;
  const [Countries, setCountries] = useState([]);
  const [countryCode, setCountryCode] = useState(currentLogin.phone_code);
  const [countryIso, setCountryIso] = useState();

  const { loading: countryLoading, error: countryError, data: countryData } = useQuery(
    gql`
      query {
        getCountry {
          countries {
            id
            name
            dial_code
            code
          }
        }
      }
    `
  );

  useEffect(() => {
    if (!countryData) return;
    if (!currentLogin) return;
    let result = countryData.getCountry.countries;
    let countArr = [];
    let code = null;

    for (let res of result) {
      if (res.name != "Canada") {
        let obj = {
          label: res.dial_code,
          id: res.dial_code,
          code: res.code,
        };
        countArr.push(obj);
      }
      if (currentLogin.phone_code == res.dial_code) {
        code = res.code;
      }
    }
    if (code) setCountryIso(code);
    const sortedOptions = countriesSort(countArr);
    setCountries(sortedOptions);
    // setCountries(countArr);
  }, [countryData, currentLogin]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (values.p1 == undefined) {
        form.setFields({
          phoneNumber: {
            value: values.phoneNumber,
            errors: [new Error("Please enter valid phone number.")],
          },
        });
        return;
      }

      let ph = values.p1;

      if (!err) {
        setLoading(true);
        ph = extractPhone(ph);
        let variables = { phoneCode: countryCode, phoneNumber: ph, id: currentLogin.id };

        let result = await client.mutate({
          mutation: gql`
            mutation editUser($id: Int!, $phoneNumber: String, $phoneCode: String) {
              editUser(id: $id, phoneNumber: $phoneNumber, phone_code: $phoneCode) {
                ok
                errors {
                  message
                }
              }
            }
          `,
          variables: variables,
        });

        if (result && result.data.editUser.ok) {
          refetch();
          notification.success({ message: "Phone number update successfully" });
        } else notification.error({ message: "Phone number not update" });

        setChangePhoneShow(false);
        setLoading(false);
      }
    });
  };

  const phondeCodeHandler = (val) => {
    setCountryCode(val.id);
    setCountryIso(val.code);
    form.setFields({
      p1: {
        value: undefined,
      },
    });
  };

  const validatePhone = (_, value, callback) => {
    if (value && typeof value == "string") {
      const phoneNumber = isValidPhoneNumber(value, countryIso);
      if (!phoneNumber) {
        callback("Please enter valid phone number.");
      } else callback();
    } else callback();
  };

  const handleCountrySelectChange = (inputValue) => {
    const sortedOptions = countriesSort(Countries, inputValue);
    setCountries(sortedOptions);
  };

  return (
    <div className="public-form-wrapper">
      <FormWrapper className="public-form">
        <div className="unitifi-login-header-bar">
          <h5>Update Phone Number</h5>
        </div>
        <Form layout="vertical" onSubmit={handleSubmit}>
          <FormItem className="uni-password-label" label="Current Number" labelCol={{ span: 12 }}>
            <p>{currentLogin && currentLogin.phoneNumber && formatNumber(currentLogin.phone_code, currentLogin.phoneNumber)}</p>
          </FormItem>
          <FormItem className="input-phone__wrapper" label="Phone Number">
            <InputGroup compact className="unitifi-number-inputbox-wrapper">
              <Select
                options={Countries}
                defaultValue={currentLogin.phone_code && currentLogin.phone_code ? { label: currentLogin.phone_code, value: currentLogin.phone_code } : { label: "+1", value: "+1" }}
                onInputChange={handleCountrySelectChange}
                onKeyDown={(event) => {
                  if (
                    event.key == "Backspace" ||
                    event.key == "Delete" ||
                    event.key == "ArrowLeft" ||
                    event.key == "ArrowRight" ||
                    event.key == "Meta" ||
                    event.key == "ArrowUp" ||
                    event.key == "ArrowDown" ||
                    event.key == "Enter" ||
                    event.key == "Tab"
                  ) {
                  } else if (!/[0-9+]/.test(event.key)) event.preventDefault();
                }}
                onChange={(val) => phondeCodeHandler(val)}
                className="unitifi-select-container phoneInputBox"
                classNamePrefix="unitifi-react-select"
              />
              {getFieldDecorator("phoneNumber", {
                rules: [
                  {
                    required: true,
                    message: "Phone is required",
                  },
                  {
                    validator: validatePhone,
                  },
                ],
              })(
                <div className="input-phone__input">
                  {getFieldDecorator("p1", {
                    rules: [
                      {
                        required: true,
                        message: "Phone is required",
                      },
                    ],
                  })(<PhoneInput countryCode={countryIso} />)}
                </div>
              )}
            </InputGroup>
          </FormItem>
          <div className="modal-footer-bnts-wrapper">
            <Button type="primary" size="large" htmlType="submit" loading={loading} disabled={loading} className="unitifi-login-btn">
              Save
            </Button>
            <Button type="" size="large" htmlType="button" className="unitifi-login-btn" onClick={() => setChangePhoneShow(false)}>
              Cancel
            </Button>
          </div>
        </Form>
      </FormWrapper>
    </div>
  );
};

export default Form.create()(changePhoneNumber);
